import { Jwt } from '@cflin/auth';
import { config } from '@cflin/config';

export const jwt = new Jwt({
  issuer: `https://${config.auth0.domain}/`,
  jwksUri: `https://${config.auth0.domain}/.well-known/jwks.json`,
});
